import { render, staticRenderFns } from "./ajout-culture-modal.vue?vue&type=template&id=38be07d4&scoped=true"
import script from "./ajout-culture-modal.vue?vue&type=script&lang=js"
export * from "./ajout-culture-modal.vue?vue&type=script&lang=js"
import style0 from "./ajout-culture-modal.vue?vue&type=style&index=0&id=38be07d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38be07d4",
  null
  
)

export default component.exports